import { render, staticRenderFns } from "./UserMenu.vue?vue&type=template&id=037e8497&scoped=true&"
import script from "./UserMenu.vue?vue&type=script&lang=ts&"
export * from "./UserMenu.vue?vue&type=script&lang=ts&"
import style0 from "./UserMenu.vue?vue&type=style&index=0&id=037e8497&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037e8497",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VDivider,VHover,VIcon,VImg,VList,VListItem,VListItemIcon,VListItemTitle,VMenu})
